module.exports = __webpack_public_path__ + "img/user-2.6052b1e9.png";